import React from 'react';
import PropTypes from 'prop-types';
import { BoldTitle } from '../../CustomizedComponents/Texts';
import SectionWrapper from '../../CardRow/SectionWrapper';
import CustomTextField from '../../CustomizedComponents/CustomTextField';
import CustomNumberFormat from '../../CustomizedComponents/CustomNumberFormat';
import { useIntl } from 'react-intl';
import { SelectorOptions } from '../../SelectorOptions/SelectorOptions';

const getOptions = (option) => {
  return option.map((item) => (
    <option key={item.id} value={item.id}>
      {item.name}
    </option>
  ));
};

const SequentiallyPurchase = ({ contract, handlers, editable, isNew, register, errors, enums }) => {
  const { isMonthlyPurchaseAvailable, quantity, maxPurchaseCount, purchaseIndexTypeId, referencePrice, isMonthlyPurchaseAvailableList } = contract;

  const { setQuantity, setMaxPurchaseCount, setIsMonthlyPurchaseAvailable, setPurchaseIndexTypeId, setReferencePrice } = handlers;

  const { purchaseIndexTypes } = enums;
  const intl = useIntl();
  const gradualBuy = 'app.contract.gradualBuy';
  const products = 'app.stockMarket.products';
  const quantityTitle = 'app.quantity';
  const dataMissing = intl.formatMessage({ id: 'app.data.missing' });
  const maxPurchaseCountTitle = 'app.maxPurchaseCount';
  const purchaseType = 'app.contract.purchaseType';
  const referencePriceTitle = 'app.contract.referencePrice';

  return (
    <>
      <SectionWrapper>
        <BoldTitle title={gradualBuy} />
        <CustomTextField
          id="isMonthlyPurchaseAvailable"
          name="isMonthlyPurchaseAvailable"
          onChange={(event) => {
            setIsMonthlyPurchaseAvailable(Number(event.target.value));
          }}
          select
          title={products}
          value={isMonthlyPurchaseAvailable}
          disabled={!editable}
          SelectProps={{
            native: true,
          }}
          variant="outlined"
          inputRef={register({
            required: dataMissing,
          })}
          helperText={errors.isMonthlyPurchaseAvailable && errors.isMonthlyPurchaseAvailable.message ? errors.isMonthlyPurchaseAvailable.message : ''}
          error={!!errors.isMonthlyPurchaseAvailable}>
          <SelectorOptions options={isMonthlyPurchaseAvailableList} translateOptions={true}></SelectorOptions>
        </CustomTextField>
        <CustomTextField
          name="quantity"
          onChange={(event) => {
            setQuantity(event.target.value);
          }}
          title={quantityTitle}
          value={quantity}
          variant="outlined"
          disabled={!editable}
          InputProps={{
            inputComponent: CustomNumberFormat,
          }}
          inputRef={register({
            required: dataMissing,
          })}
          helperText={errors.quantity && errors.quantity.message ? errors.quantity.message : ''}
          error={!!errors.quantity}
        />
        <CustomTextField
          name="maxPurchaseCount"
          onChange={(event) => {
            setMaxPurchaseCount(event.target.value);
          }}
          title={maxPurchaseCountTitle}
          value={maxPurchaseCount}
          variant="outlined"
          disabled={!editable}
          InputProps={{
            inputComponent: CustomNumberFormat,
          }}
          inputRef={register({
            required: dataMissing,
          })}
          helperText={errors.maxPurchaseCount && errors.maxPurchaseCount.message ? errors.maxPurchaseCount.message : ''}
          error={!!errors.maxPurchaseCount}
        />
        <CustomTextField
          id="purchaseIndexType"
          name="purchaseIndexType"
          onChange={(event) => {
            setPurchaseIndexTypeId(event.target.value);
          }}
          select
          title={purchaseType}
          value={purchaseIndexTypeId}
          disabled={isNew ? false : true}
          SelectProps={{
            native: true,
          }}
          variant="outlined"
          inputRef={register({
            required: dataMissing,
          })}
          helperText={errors.purchaseIndexType && errors.purchaseIndexType.message ? errors.purchaseIndexType.message : ''}
          error={!!errors.purchaseIndexType}>
          <option value={null} />
          {getOptions(purchaseIndexTypes)}
        </CustomTextField>
        {purchaseIndexTypeId === 'RP' && (
          <CustomTextField
            name="referencePrice"
            onChange={(event) => {
              setReferencePrice(event.target.value);
            }}
            title={referencePriceTitle}
            value={referencePrice}
            variant="outlined"
            disabled={!editable}
            inputRef={register({
              required: dataMissing,
            })}
            InputProps={{
              inputComponent: CustomNumberFormat,
            }}
            helperText={errors.referencePrice && errors.referencePrice.message ? errors.referencePrice.message : ''}
            error={!!errors.referencePrice}
          />
        )}
      </SectionWrapper>
    </>
  );
};

SequentiallyPurchase.propTypes = {
  contract: PropTypes.object,
  handlers: PropTypes.object,
  editable: PropTypes.bool,
  isNew: PropTypes.bool,
  enums: PropTypes.any,
  register: PropTypes.any,
  errors: PropTypes.object,
};

export default SequentiallyPurchase;
